import { defaultClient } from '@api/client';

export const approvePost = ({ id }) => {
  return defaultClient.put(`/publisher/posts/${id}/approve`);
};

export const denyPost = ({ id }, reason) => {
  return defaultClient.put(`/publisher/posts/${id}/deny`, { reason });
};
